import PropTypes from "prop-types";
import { DashboardGridSkeleton } from "../../dashboard-skeletons/dashboard-skeletons";
import LevfinDealTracker from "../levfin-deal-tracker/levfin-deal-tracker";
import LevfinMembersTimeLog from "./levfin-members-time-log";

const LevfinStaffer = (props) => {
    return (
        <div>
            {
                props.isLevfinStafferTimeLogLoading ?
                    <DashboardGridSkeleton width="95vw" />
                    : props.levfinStafferTimeLogItems &&
                    <LevfinMembersTimeLog members={props.levfinStafferTimeLogItems} fetchLevfinStafferTimeLog={props.fetchLevfinStafferTimeLog} setIsLevfinStafferTimeLogLoading={props.setIsLevfinStafferTimeLogLoading} />
            }
            {
                props.isLevfinDealTrackerLoading ?
                    <DashboardGridSkeleton width="95vw" />
                    : props.levfinDealTrackerItems &&
                    <LevfinDealTracker items={props.levfinDealTrackerItems} isStafferView={true} />
            }
        </div>
    );
};

export default LevfinStaffer;